import { FormFileInput } from "./FormFileInput";
import type { FormState } from "./type";
import type { FormFieldData, FormValueType } from "@/model/form";
import type {
  ControllerRenderProps,
  UseFormReturn,
} from "@deputy-ai/ui/form/Form";
import { Input } from "@deputy-ai/ui/input/Input";
import { InputNumber } from "@deputy-ai/ui/input/InputNumber";
import { Select } from "@deputy-ai/ui/select/Select";
import { Textarea } from "@deputy-ai/ui/textarea/Textarea";

export const FormFieldInput = (props: {
  form: UseFormReturn<Record<string, FormValueType>>;
  formField: FormFieldData;
  field: ControllerRenderProps<Record<string, FormValueType>, string>;
  formState: FormState;
  disabled: boolean;
}) => {
  const { formField, field, disabled: disabledInput, formState } = props;

  const disabledByFormState =
    formState === "submitted" || formState === "submitting";

  const disabled = disabledInput || disabledByFormState;

  if (formField.def.field_type === "file") {
    return <FormFileInput {...props} />;
  }

  if (formField.def.field_type === "number") {
    return (
      <InputNumber
        className="bg-white"
        {...field}
        value={Number(field.value)}
        disabled={disabled}
      />
    );
  }

  if (formField.def.attrs?.options?.length) {
    return (
      <Select
        {...field}
        className="bg-white"
        onValueChange={field.onChange}
        value={String(field.value ?? "")}
        disabled={disabled}
      >
        {formField.def.attrs.options
          .filter((o) => o.value)
          .map((option) => (
            <Select.Item key={option.value} value={option.value}>
              {option.label}
            </Select.Item>
          ))}
      </Select>
    );
  }

  if (formField.def.attrs?.multiline) {
    return <Textarea className="bg-white" {...field} disabled={disabled} />;
  }

  return (
    <Input
      type={getFormFieldInputType(formField)}
      className="bg-white"
      {...field}
      disabled={disabled}
    />
  );
};

function getFormFieldInputType(field: FormFieldData): string {
  if (field.def.attrs?.email) {
    return "email";
  }
  return "text";
}
